<script setup lang="ts">
import { DropdownMenuArrow, DropdownMenuContent, DropdownMenuItem, DropdownMenuRoot, DropdownMenuSeparator, DropdownMenuTrigger } from "reka-ui";

const { account, isLoggedIn } = useAccount();
const { siteOptions } = useSiteOptions();
const { cart } = useCart();
</script>

<template>
  <UiNavButton v-if="!isLoggedIn" as="a" :href="siteOptions.login_url" label="Connexion">
    <span class="i-local-account" />
  </UiNavButton>
  <DropdownMenuRoot v-else-if="account" :modal="false">
    <DropdownMenuTrigger>
      <UiNavButton as="button" label="Mon compte">
        <span class="i-local-account" />
      </UiNavButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="animation-fade z-dropdown mobile:-translate-x-4 mobile:translate-y-8">
      <div class="overflow-hidden rounded-md shadow-lg">
        <div class="dark color-dark px-8 py-4 text-center ">
          <div class="w-64 overflow-hidden text-ellipsis font-bold">
            Bienvenue {{ account.display_name }}!
          </div>
          <div v-if="cart" class="text-sm">
            Vous avez <span class="text-base font-bold text-primary">{{ integer(cart.lillopoints.total_points) }}</span> Lillopoints!
          </div>
        </div>
        <div class="links:link-primary bg-white px-4 py-2 font-medium text-black">
          <DropdownMenuItem v-for="item in account.menu_items" :key="item.id">
            <a :href="item.url" :target="item.target" class="flex py-1">{{ item.title }}</a>
          </DropdownMenuItem>
          <DropdownMenuSeparator class="my-1 h-0.5 bg-primary" />
          <DropdownMenuItem>
            <a :href="siteOptions.logout_url" class="flex py-1">Déconnexion</a>
          </DropdownMenuItem>
        </div>
      </div>
      <DropdownMenuArrow class="fill-dark mobile:-translate-x-4" />
    </DropdownMenuContent>
  </DropdownMenuRoot>
</template>
